import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map,switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { AdminConsumerStatsState } from "../../models/mp-admin/consumer-stats-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AdminConsumerStatsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerStats.get),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerStats)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.consumerStats.getSuccess(state))
					: of(MpAdminActions.consumerStats.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerStats.getApi),
			withLatestFrom(this.store.select(MpAdminSelectors.consumerStats)),
			switchMap(() =>
				this.adminService.consumerStats().pipe(
					map((stats) =>
						MpAdminActions.consumerStats.getSuccess({ stats, loading: false })
					),
					catchError((error) =>
						of(MpAdminActions.consumerStats.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private adminService: MpAdminService
	) {}

	private canUseStoreValue(action, state: AdminConsumerStatsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
